
import { BiltyFormat3 } from "BiltyFomates";
import { getSupplerReportApi } from "_services";
import { CommonModal, CustomSelect } from "components";

import { API, AppConfig } from "lib";
import React, { useEffect, useState } from "react";
import moment from "moment";
import StorageService from "utils/StorageServices/StorageServices";
import { Images } from "constants";
import { StorageServices } from "utils";


const SupplierTripReport = (props) => {
    const { freightId } = props;
    const [loading, setLoading] = useState(false);
    const [loadingBilty, setLoadingBilty] = useState(false)
    let isToken = localStorage.getItem("token");
    const [buityFormatePreview, setBuityFormatePreview] = useState('')
    const [isLoaddingPrint, setIsLoaddingPrint] = useState(false)
    const companyId = StorageServices.getCompanyId()

    useEffect(() => {
        if (companyId && freightId) {
            getSupplierTripapi()
        }
    }, [companyId, freightId])

    const getSupplierTripapi = async () => {

        setLoadingBilty(true)
        try {

            const res = await getSupplerReportApi({
                company_id: StorageService?.getCompanyId(),
                trip_id: freightId
            });

            setBuityFormatePreview(res)

            if (res) {
                setLoadingBilty(false)
            }

        } catch (error) {
        }
    };

    // const handleDownload = async () => {
    //     try {
    //         const payload = {
    //             company_id: StorageService?.getCompanyId(),
    //             trip_id: freightId
    //         }
    //         setIsLoaddingPrint(true)
    //         const response = await fetch(`${AppConfig.api_baseurl}${API.SUPPLIER_REPORT_DOWNLOAD}`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Token': `${isToken}`,
    //             },
    //             body: JSON.stringify(payload)
    //         });

    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }

    //         const blob = await response.blob();
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = `Supplier-report/${moment(new Date()).format("D MMM YYYY")}.pdf`;
    //         document.body.appendChild(a);
    //         a.click();
    //         a.remove();
    //         setIsLoaddingPrint(false)
    //     } catch (error) {
    //         setIsLoaddingPrint(false)
    //     }
    // }

     const handleDownload = async () => {
        try {
            const payload = {
                company_id: StorageService?.getCompanyId(),
                trip_id: freightId
            }
            setIsLoaddingPrint(true)
            const response = await fetch(`${AppConfig.api_baseurl}${API.SUPPLIER_REPORT_DOWNLOAD}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });
    
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
    
            // Get filename from Content-Disposition header
            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = `supplier-report-${moment(new Date()).format("D MMM YYYY")}.pdf`; // fallback
            
            if (contentDisposition) {
                // Try to extract filename from Content-Disposition header
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].replace(/['"]/g, '');
                    // Decode if it's URL encoded
                    filename = decodeURIComponent(filename);
                }
            }
    
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object
            setIsLoaddingPrint(false)
        } catch (error) {
            setIsLoaddingPrint(false)
        }
    }

    const formatePrpsTrip = {
        buityFormatePreview: buityFormatePreview
    };



    const propsBuiltyPrint = {
        ...props,
        // onSubmit:handlePrint
        // onPrint: handleDownload,
        onSubmit: handleDownload,
        isLoadding: isLoaddingPrint,
        disabled: isLoaddingPrint,
        isLoaddingPrint: isLoaddingPrint
    };



    return (
        <>
            <CommonModal {...propsBuiltyPrint}>
                <div className="bltyPrint_body" style={{ display: "block" }}>
                    <div className="bltyPrt_viewPage_bx" id="print-area">

                        {!loadingBilty ? <BiltyFormat3 {...formatePrpsTrip} /> : <div colSpan="100%" style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                            <img className="_loadWidth" style={{ width: "150px", color: "f2f2f2" }} src={Images.LOADINGTRUCK} alt="" />
                        </div>}
                    </div>
                </div>
            </CommonModal>


        </>
    );
};

export default SupplierTripReport;
